import React from 'react';
import { useTranslation } from 'react-i18next';

const UserHoverCard = ({ profile, position, style }) => {
    const { t } = useTranslation();
    if (!profile) return null;
    return (
        <div className="user-hover-card" style={{ top: position.top, left: position.left, ...style }}>
            <img src={profile.photoURL || "https://placehold.co/40x40/AEC6CF/FFFFFF?text=U"} alt={profile.displayName} className="w-10 h-10 rounded-full object-cover border-2 border-gray-600" />
            <div>
                <p className="font-bold text-sm text-white">{profile.displayName}</p>
                <p className="text-xs text-cyan-300">{t('userHoverCard.constellationLevel', { level: profile.constellationLevel || 1 })}</p>
            </div>
        </div>
    );
};

export default UserHoverCard;
